import styled from '@emotion/styled'

export const StyledVerticalDivider = styled.div`
  border-right: solid 1px var(--White90);
`
